import { CreatomateFont, BuiltInFontDefinition } from "./BuiltInFonts";

export const CreatomateTargetFonts: CreatomateFont[] = [
  {
    family: "HelveticaForTarget",
    weight: 400,
    style: "normal",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget.otf"
  },
  {
    family: "HelveticaForTarget Italic",
    weight: 400,
    style: "italic",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-Italic.otf"
  },
  {
    family: "HelveticaForTarget Bold",
    weight: 700,
    style: "normal",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-Bold.otf"
  },
  {
    family: "HelveticaForTarget Bold Italic",
    weight: 700,
    style: "italic",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-BoldItalic.otf"
  },
  {
    family: "HelveticaForTarget Heavy",
    weight: 800,
    style: "normal",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-Heavy.otf"
  },
  {
    family: "HelveticaForTarget Heavy Italic",
    weight: 800,
    style: "italic",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-HeavyItalic.otf"
  },
  {
    family: "HelveticaForTarget Light",
    weight: 300,
    style: "normal",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-Light.otf"
  },
  {
    family: "HelveticaForTarget Light Italic",
    weight: 300,
    style: "italic",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-LightItalic.otf"
  },
  {
    family: "HelveticaForTarget Medium",
    weight: 500,
    style: "normal",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-Medium.otf"
  },
  {
    family: "HelveticaForTarget Medium Italic",
    weight: 500,
    style: "italic",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-MediumItalic.otf"
  },
  {
    family: "HelveticaForTarget RmPl",
    weight: 600,
    style: "normal",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-RmPl.otf"
  },
  {
    family: "HelveticaForTarget RmPl Italic",
    weight: 600,
    style: "italic",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-RmPlIt.otf"
  },
  {
    family: "HelveticaForTarget Thin",
    weight: 200,
    style: "normal",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-Thin.otf"
  },
  {
    family: "HelveticaForTarget Thin Italic",
    weight: 200,
    style: "italic",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-ThinItalic.otf"
  }
];

export const BuiltInTargetFonts: BuiltInFontDefinition[] = [
  {
    family: "HelveticaForTarget",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget.otf"
  },
  {
    family: "HelveticaForTarget Italic",
    weights: [400],
    styles: ["italic"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-Italic.otf"
  },
  {
    family: "HelveticaForTarget Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-Bold.otf"
  },
  {
    family: "HelveticaForTarget Bold Italic",
    weights: [700],
    styles: ["italic"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-BoldItalic.otf"
  },
  {
    family: "HelveticaForTarget Heavy",
    weights: [800],
    styles: ["normal"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-Heavy.otf"
  },
  {
    family: "HelveticaForTarget Heavy Italic",
    weights: [800],
    styles: ["italic"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-HeavyItalic.otf"
  },
  {
    family: "HelveticaForTarget Light",
    weights: [300],
    styles: ["normal"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-Light.otf"
  },
  {
    family: "HelveticaForTarget Light Italic",
    weights: [300],
    styles: ["italic"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-LightItalic.otf"
  },
  {
    family: "HelveticaForTarget Medium",
    weights: [500],
    styles: ["normal"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-Medium.otf"
  },
  {
    family: "HelveticaForTarget Medium Italic",
    weights: [500],
    styles: ["italic"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-MediumItalic.otf"
  },
  {
    family: "HelveticaForTarget RmPl",
    weights: [600],
    styles: ["normal"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-RmPl.otf"
  },
  {
    family: "HelveticaForTarget RmPl Italic",
    weights: [600],
    styles: ["italic"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-RmPlIt.otf"
  },
  {
    family: "HelveticaForTarget Thin",
    weights: [200],
    styles: ["normal"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-Thin.otf"
  },
  {
    family: "HelveticaForTarget Thin Italic",
    weights: [200],
    styles: ["italic"],
    category: "other",
    source: "https://assets.culturehq.com/fonts/target/HelveticaforTarget-ThinItalic.otf"
  }
];
